<div class="filter-dialog-header">
  <h2 class="filter-dialog-title">Filtrar Foco por: {{ tipo }}</h2>
  <button mat-icon-button (click)="closeDialog()" aria-label="Fechar" class="filter-dialog-close">
    <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
  </button>
</div>
<div mat-dialog-content class="filter-dialog-content">
  <table mat-table [dataSource]="dataSource" class="filter-table">
    <ng-container matColumnDef="codigo">
      <th mat-header-cell *matHeaderCellDef sticky> Código </th>
      <td mat-cell *matCellDef="let element"> {{element.produto.cod_produto}} </td>
    </ng-container>
    <ng-container matColumnDef="nome">
      <th mat-header-cell *matHeaderCellDef sticky> Produto </th>
      <td mat-cell *matCellDef="let element"> {{element.produto.nome}} </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef sticky> Ativo </th>
      <td mat-cell *matCellDef="let element">
        <mat-checkbox [checked]="element.status" class="foco-checkbox" (change)="updateStatus(element)"></mat-checkbox>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
